<template>
    <div class="fixed top-10 right-4 z-50 space-y-2">
        <div
            v-for="toast in toasts"
            :key="toast.id"
            :class="[
                'px-4 py-3 rounded-lg shadow flex items-center gap-3 min-w-80 animate-slide-in bg-white',
            ]"
            :style="toast.color ? { backgroundColor: toast.color + '20', borderColor: toast.color + '40', color: toast.color } : {}"
        >
            <div :class="[
                'w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0',
                getIconClasses(toast)
            ]"
            :style="toast.color ? { backgroundColor: toast.color } : {}"
            >
                <!-- Custom icon if provided -->
                <div v-if="toast.icon" v-html="toast.icon" class="w-4 h-4 text-white"></div>
                
                <!-- Success icon (checkmark) -->
                <svg v-else-if="toast.type === 'success'" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                
                <!-- Disabled icon (X mark) -->
                <svg v-else-if="toast.type === 'disabled'" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
                
                <!-- Default error icon -->
                <svg v-else class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </div>
            
            <div class="flex-1">
                <div v-if="toast.title" class="font-bold text-gray-800 mb-1">
                    {{ toast.title }}
                </div>
                <div :class="toast.title ? 'text-sm text-gray-800' : 'font-medium text-gray-800'">
                    {{ toast.message }}
                </div>
            </div>
            
            <button 
                @click="remove(toast.id)"
                class="text-gray-400 hover:text-gray-600 flex-shrink-0"
            >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script setup>
import { useToast } from '../stores/toast'

const { toasts, remove } = useToast()

const getToastClasses = (toast) => {
    if (toast.color) return 'border'
    
    // For success/disabled types, use same neutral styling
    if (toast.type === 'success' || toast.type === 'disabled') {
        return 'bg-white border border-gray-200 text-gray-800'
    }
    
    // Error type uses red styling
    return 'bg-white border border-gray-200 text-gray-800'
}

const getIconClasses = (toast) => {
    if (toast.color) return ''
    
    if (toast.type === 'success') return 'bg-green-500'
    if (toast.type === 'disabled') return 'bg-red-500'
    return 'bg-red-500' // error type
}
</script>

<style scoped>
@keyframes slide-in {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.animate-slide-in {
    animation: slide-in 0.3s ease-out;
}
</style>